// 機具警報蜂鳴器連動：主題顯示 / 格式驗證的純函式。
//
// 這裡故意不知道主題格式（indoor_positioning/<machine_id>/equipment/<id>/alarm）
// 本身——那個格式只存在後端 controller/equipment/buzzer_service.py 一處，前端
// 只消費後端已經算好的 buzzer_topic_default，避免兩邊格式漂移。

/**
 * 決定表單上該顯示哪個「目前生效主題」。
 *
 * 規則：
 * - typedTopic 去除頭尾空白後非空 -> 使用者輸入即生效主題（"custom"）。
 * - typedTopic 為空/未輸入，且有 defaultTopic -> 使用預設主題（"default"）。
 * - 兩者皆無（例如新增模式尚未有機具 id）-> 無主題可顯示（"unavailable"）。
 *
 * @param {{ typedTopic?: string|null, defaultTopic?: string|null }} args
 * @returns {{ topic: string|null, source: "custom" | "default" | "unavailable" }}
 */
export function resolveDisplayTopic({ typedTopic, defaultTopic } = {}) {
  const trimmed = typeof typedTopic === "string" ? typedTopic.trim() : "";
  if (trimmed !== "") {
    return { topic: trimmed, source: "custom" };
  }
  if (defaultTopic) {
    return { topic: defaultTopic, source: "default" };
  }
  return { topic: null, source: "unavailable" };
}

/**
 * 蜂鳴器 MQTT 主題的前端格式檢查（與 EquipmentFormModal 的
 * `buzzer_mqtt_topic` 欄位驗證規則相同，供表單驗證與「複製主題」按鈕的顯示
 * 判斷共用，避免同一組規則被實作兩次而彼此漂移）。
 *
 * 空白值視為合法（代表「使用預設主題」），因為這裡只檢查「使用者有輸入時，
 * 輸入的內容格式對不對」，不是「有沒有輸入」。
 *
 * @param {string|null|undefined} value
 * @returns {boolean}
 */
export function isValidBuzzerTopicFormat(value) {
  if (value == null || String(value).trim() === "") return true;
  const trimmed = String(value).trim();
  if (trimmed.length > 255) return false;
  if (trimmed.includes("+") || trimmed.includes("#")) return false;
  if (trimmed.startsWith("$")) return false;
  return true;
}
